import { compose, withPropsOnChange, branch } from "recompose"

import {
  getDefectsByVisit,
  getDefectsPlanned,
} from "../../../api/entities/actualDefects"
import withApiTransport from "../../../api/apiTransport"
import { ISSUE_TYPE_CODES } from "../../../api/entities/issue"

const withDefectsByTechReviewIssue = compose(
  withPropsOnChange([`issue`], ({ issue: { id } = {} }) => ({
    load: getDefectsByVisit,
    propName: `actualDefects`,
    payload: id,
  })),
  withApiTransport,
)

const withDefectsByRepairIssue = compose(
  withPropsOnChange([`issue`], ({ issue: { id } = {} }) => ({
    load: getDefectsPlanned,
    propName: `actualDefects`,
    payload: id,
  })),
  withApiTransport,
)

const enhance = compose(
  branch(
    ({ issue: { type: { key } = {} } = {} }) => key === ISSUE_TYPE_CODES.repair,
    withDefectsByRepairIssue,
    withDefectsByTechReviewIssue,
  ),
)

export default enhance
